import { Component, OnInit } from '@angular/core';
import { LibraryService } from 'src/app/services/Library/library.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-book-type',
  templateUrl: './book-type.component.html',
  styleUrls: ['./book-type.component.css']
})
export class BookTypeComponent implements OnInit {
  Submitted:boolean=false;
  ItemTypeList=[];

  constructor(private  libraryservice: LibraryService,private lookupservice: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }


BookMSTModel =
      {
          BookTypeID: 0,
          ItemTypeID: 0,
          BookType: '',

      }
  BookTypeMSTList= [];

  Clear = function () {
      this.BookMSTModel.BookType = '';
      this.BookMSTModel.BookTypeID = 0;
      this.BookMSTModel.ItemTypeID = 0;
      this.Submitted = false;
  }
  GetItemType = function () {
      this.lookupservice.GetLookupsList('ItemType', '').subscribe((data:any)=> {
          this.ItemTypeList = data.LookupItems;
      });
  };
Validation = function () {
      return this.BookMSTModel.ItemTypeID == 0 || this.BookMSTModel.ItemTypeID == '0' || this.BookMSTModel.ItemTypeID == '';
  }
 
  Save(valid) {
      this.Submitted = true;
      if (valid && !this.Validation()) {
        this.spinnerService.show();

          this.libraryservice.SaveBookType(JSON.stringify(this.BookMSTModel)).subscribe( (response:any) => {
            this.spinnerService.hide();
                  this.Submitted = false;
            
              this.globalHelper.CheckActionStatus(response);
              this.GetAllBookTypeMST();
              this.Clear();
          })
      }
  }

  Edit(obj) {

      this.BookMSTModel.BookTypeID = obj.BookTypeID;
      this.BookMSTModel.ItemTypeID = obj.ItemTypeID;
      this.BookMSTModel.BookType = obj.BookType;
  }

  GetAllBookTypeMST () {
     this.spinnerService.show();
      this.libraryservice.GetAllBookType().subscribe( (response:any)=> {
          this.BookTypeMSTList = response.BookTypeMSTList;
         this.spinnerService.hide();
      });
  }



  ngOnInit() {
    this.GetItemType();
            this.GetAllBookTypeMST();
  }

}
